import React from 'react';
import analytics from '../../../../modules/analytics';
import { sendClientApptSmsRequest } from '../../../../modules/api/clients/sms';
import { IProviderClient } from '../../../../api/Providers/Clients/types';
import { ApptSmsInviteDialog } from './ApptSmsInviteDialog';

export type ApptSmsInviteDialogContainerProps = {
  client: Pick<IProviderClient, 'id'>;
  source: string;
  trackingPrefix: string;
  onInviteSent?: () => void;
  onInviteSending?: () => void;
  onInviteFailed?: () => void;
  onInviteCancel?: () => void;
};

export const ApptSmsInviteDialogContainer: React.FC<ApptSmsInviteDialogContainerProps> = ({
  client,
  source,
  trackingPrefix,
  onInviteSent,
  onInviteSending,
  onInviteFailed,
  onInviteCancel,
}) => {
  const handleSmsInviteConfirm = () => {
    analytics.track(`${trackingPrefix}client_invite_modal_confirm_clicked`);
    onInviteSending?.();
    sendClientApptSmsRequest(client.id, source)
      .then(() => {
        onInviteSent?.();
      })
      .catch(() => {
        onInviteFailed?.();
      });
  };

  const handleSmsInviteCancel = () => {
    analytics.track(`${trackingPrefix}client_invite_modal_cancel_clicked`);
    onInviteCancel?.();
  };

  return (
    <ApptSmsInviteDialog
      onSendInvite={handleSmsInviteConfirm}
      onClose={handleSmsInviteCancel}
    />
  );
};
